"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductMarquee = ProductMarquee;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _image = require("@site/pattern-library-core/image");
var _index = _interopRequireDefault(require("../../../elements/other/card/index.js"));
var _productMarqueeSingle = _interopRequireDefault(require("./product-marquee-single"));
var _productMarqueeDual = _interopRequireDefault(require("./product-marquee-dual"));
var _index2 = _interopRequireDefault(require("../../../elements/other/actions/index.js"));
var _tooltip = _interopRequireDefault(require("@site/pattern-library-core/tooltip"));
var _countdownClock = _interopRequireDefault(require("@site/pattern-library-core/countdown-clock"));
/* eslint-disable complexity */

/**
 * Render product marquee.
 * @module ProductMarquee
 *
 * @param {object} props React props
 * @param {object} props.secondaryCard Secondary Card (optional)
 * @param {object} props.domainSearch DomainSearch  (optional)
 * @param {React.ReactElement} props.attribution Attribution name and url (optional)
 * @param {object} props.backgroundImages Object of background images for all breakpoints.
 * @param {object} props.colors Object of colors for primary and secondary cards
 * @param {object} [props.card] primary card props for the text lockup side
 * @param {object} props.priceLockup Price Lockup
 * @returns {React.ReactElement} Full Marqueecomponent
 * @public
 */
function ProductMarquee({
  secondaryCard,
  domainSearch,
  ctas,
  attribution,
  portrait,
  landscape,
  marqueeLayout = 'centered-single',
  tabletPortraitBackground,
  tablet,
  invert,
  partial,
  textAlign = 'start',
  disclaimerTooltip,
  card,
  priceLockup,
  countdownClock,
  attributionHeadline,
  attributionDescription,
  ...cardProps
}) {
  partial = partial || (invert ? 'dark1' : '');

  /* translate the properties from SWP here */
  const backgroundImages = {
    mobile: portrait?.url,
    desktop: landscape?.url,
    tablet: tablet?.url || tabletPortraitBackground?.url
  };
  const domainSearchElement = domainSearch && (/*#__PURE__*/_react.default.isValidElement(domainSearch) ? domainSearch : /*#__PURE__*/_react.default.createElement(_index2.default, {
    actionsLayout: "domain-search",
    ctas: [domainSearch]
  }));
  const ctasNormalized = ctas && (/*#__PURE__*/_react.default.isValidElement(ctas) ? ctas : /*#__PURE__*/_react.default.createElement(_index2.default, {
    actionsLayout: "button-set",
    ctas: ctas
  })) || domainSearchElement;
  const cardNormalized = {
    ...cardProps,
    ctas: ctasNormalized,
    textAlign,
    disclaimerTooltip: disclaimerTooltip || card?.disclaimerTooltip || card?.tooltip
  };
  const countdownClockElement = countdownClock && (/*#__PURE__*/_react.default.isValidElement(countdownClock) ? countdownClock : /*#__PURE__*/_react.default.createElement(_countdownClock.default, countdownClock));
  const incorrectSecondaryLayoutMissingSecondary = marqueeLayout.indexOf('single') === -1 && !secondaryCard;
  marqueeLayout = incorrectSecondaryLayoutMissingSecondary ? 'start-single' : marqueeLayout;
  if (marqueeLayout.indexOf('single') > -1) {
    return /*#__PURE__*/_react.default.createElement(_productMarqueeSingle.default, (0, _extends2.default)({}, cardNormalized, {
      marqueeLayout: marqueeLayout,
      backgroundImages: backgroundImages,
      attributionName: attribution,
      attributionHeadline: attributionHeadline,
      attributionDescription: attributionDescription,
      "data-partial": partial,
      card: card,
      priceLockup: priceLockup,
      countdownClock: countdownClockElement
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_productMarqueeDual.default, (0, _extends2.default)({}, cardNormalized, {
    marqueeLayout: marqueeLayout,
    backgroundImages: backgroundImages,
    attributionName: attribution,
    attributionHeadline: attributionHeadline,
    attributionDescription: attributionDescription,
    secondaryCard: secondaryCard,
    "data-partial": partial,
    card: card,
    priceLockup: priceLockup,
    countdownClock: countdownClockElement
  }));
}
ProductMarquee.propTypes = {
  portrait: _propTypes.default.shape(_image.imgPropShape),
  landscape: _propTypes.default.shape(_image.imgPropShape),
  tabletPortraitBackground: _propTypes.default.shape(_image.imgPropShape),
  tablet: _propTypes.default.shape(_image.imgPropShape),
  domainSearch: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]),
  secondaryCard: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]),
  ctas: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.node]),
  attribution: _propTypes.default.string,
  invert: _propTypes.default.bool,
  cardProps: _propTypes.default.shape({
    ..._index.default.propTypes
  }),
  disclaimerTooltip: _propTypes.default.shape(_tooltip.default.propTypes),
  card: _propTypes.default.node,
  marqueeLayout: _propTypes.default.oneOf(['centered-single', 'start-single', 'list', 'testimonial', 'text-lockup']).isRequired,
  partial: _propTypes.default.string,
  textAlign: _propTypes.default.string,
  priceLockup: _propTypes.default.object,
  countdownClock: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]),
  attributionHeadline: _propTypes.default.string,
  attributionDescription: _propTypes.default.string
};
var _default = exports.default = ProductMarquee;